import './sass/01_basis/index.scss';
import './sass/02_layout/index.scss';
// import './sass/03_plugins/index.scss';

import './js/start.js';
import './js/info.js';
import './js/doresize.js';
import './js/showpopup.js';
import './js/data/countries.js';

import './js/classes/circleclass.js';
import './js/classes/openingpopup.js';
import './js/classes/linkshape.js';

import './js/elements/popup/closeButton.js';
import './js/elements/popup/titlePopup.js';
import './js/elements/popup/emptyPopup.js';
import './js/elements/popup/comments.js';
import './js/elements/popup/tablePopup.js';
import './js/elements/popup/detailpopup.js';
import './js/elements/popup/popup.js';

import './js/functions/finddestination.js';
import './js/functions/animation.js';
import './js/functions/showtablepop.js';
import './js/functions/hidetablepop.js';
import './js/functions/removePopups.js';


import './js/script.js';


